import { css } from '@emotion/core';

import { SPACE_COMFORTABLE, VIEWING_WIDTH } from '@/styles';

export const root = css`
  width: ${VIEWING_WIDTH}px;
  margin: 0 auto;
`;

export const parentBlock = css`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const descriptionBlock = css`
  max-width: fit-content;
  line-height: 1.5;
`;

export const sloPageDataSectionStyles = css`
  padding-top: ${SPACE_COMFORTABLE}px;
`;

export const inlineSFxIconStyles = css`
  &,
  & > div {
    display: inline-flex;
    align-items: center;
    img {
      width: 22px;
      height: 22px;
    }
    vertical-align: middle;
  }
`;
